import * as types from "./types";

const toggleShowPromotionModal = () => ({
  type: types.TOGGLE_PROMOTION_MODAL,
})

const updatedAppliedPromotion = (promotions:any) => ({
  type: types.UPDATE_APPLIED_PROMOTIONS,
  payload: promotions,
});

const updatePromotionAppliedCart = (updatedCart:any[]) => ({
  type: types.UPDATE_PROMOTION_APPLIED_CART,
  payload: updatedCart,
});

const updateAppliedOrderPromotions = (promotions:any) => ({
  type: types.UPDATE_APPLIED_ORDER_PROMOTIONS,
  payload: promotions,
});

const updateFreeItemsCart = (updatedFreeItems:any[]) => ({
  type: types.UPDATE_FREE_ITEMS_CART,
  payload: updatedFreeItems,
})

const validatePromoCode = (payload: any) => ({
  type: types.VALIDATE_PROMO_CODE,
  payload: {
    request: {
      method: "post",
      url: "promotions/validate",
      data: {
        code: payload.code,
        company_id: payload.company_id,
        customer_id: payload.customer_id,
        promotion_id: payload.promotion_id,
        promo_code_id: payload.promo_code_id
      },
    }
  }
});

export {
  toggleShowPromotionModal,
  updatedAppliedPromotion,
  updatePromotionAppliedCart,
  updateAppliedOrderPromotions,
  updateFreeItemsCart,
  validatePromoCode
}
